var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPersonCheck = function SvgPersonCheck(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "person_check_svg__a",
    width: 30,
    height: 30,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#person_check_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.938 11.913 4.634-4.653a.9.9 0 0 1 .662-.28q.383 0 .675.28a.87.87 0 0 1 .284.668.93.93 0 0 1-.284.668l-5.18 5.168q-.34.34-.791.34-.453 0-.791-.34l-2.524-2.524a.92.92 0 0 1-.285-.656.9.9 0 0 1 .284-.668.9.9 0 0 1 .66-.279q.379 0 .658.279zM11.25 14.615q-1.81 0-3.092-1.282T6.875 10.24t1.283-3.092q1.281-1.283 3.092-1.283 1.81 0 3.092 1.283t1.283 3.092-1.283 3.093q-1.281 1.282-3.092 1.282m-9.375 7.62v-.88q0-.917.499-1.7a3.33 3.33 0 0 1 1.333-1.203 18 18 0 0 1 3.739-1.363 16.2 16.2 0 0 1 7.608 0q1.886.454 3.74 1.363.833.42 1.332 1.203.5.782.499 1.7v.88q0 .791-.554 1.346-.555.554-1.345.554H3.774q-.791 0-1.345-.555a1.83 1.83 0 0 1-.554-1.344"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPersonCheck);
export default ForwardRef;